import React, { useState } from "react";
import DummyProduct from "src/assets/images/product-dummy-img.png";
import ProductDetailSlider from "src/Components/WebsiteComponents/ProductDetailSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import HeartUnFav from "src/assets/images/heart-un-favorite.png";
import ShareIcon from "src/assets/images/website-images/shareicon.png";
import DangerImg from "src/assets/images/website-images/danger.png";
import { ChevronRight } from "lucide-react";
import OgxImg from "src/assets/images/website-images/Ogx.png";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import HistoryIcon from "src/assets/images/website-images/history-icon.png";
import CarIcon from "src/assets/images/website-images/carIcon.png";
import PhoneIcon from "src/assets/images/website-images/phoneIcon.png";
import CircleIcon from "src/assets/images/website-images/circleIcon.png";
import BannerImage1 from "src/assets/images/website-images/banner-image-1.png";
import BannerImage2 from "src/assets/images/website-images/banner-image-2.png";
import { Link } from "react-router-dom";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import { CURRENCY } from "src/lib/constans";

const ProductDetail = () => {
  const [quantity, setQuantity] = useState(1);

  const handleQuantityChange = (type: "inc" | "dec") => {
    setQuantity((prev) =>
      type === "inc" ? prev + 1 : prev > 1 ? prev - 1 : 1
    );
  };

  const handleThumbnailClick = () => {};

  const handleSubmit = () => {};

  let imagesPath = "/uploads/product/productImage-1749206010917-732923720.jpg";

  const infoPoints: string[] = [
    "Blood glucose test strips for self-testing and single use",
    "Benefits diabetic patients for diabetes control",
    "For quantitatively measuring glucose in whole blood",
    "To be used 6 months after opening",
    "22 months life span",
    "Test time: 5 seconds",
    "Only works with Rossmax HS200 glucose meter",
    "Measuring method: Advanced GDH-FAD Auto coding Technology",
    "Measuring range: 20~600 mg/dL (1.1 ~ 33.3mmol/L)",
    "Blood source: fresh whole capillary blood",
    "Volume of blood: min 0.7µl",
    "Pack contains 1 vial of 50 strips",
  ];

  const benefitsList = [
    {
      id: 1,
      text: "Offers 5 seconds fast test time, that too with a small quantity blood sample",
    },
    {
      id: 2,
      text: "Results are not affected by oxygen, galactose & maltose",
    },
    {
      id: 3,
      text: "Offers individuals with type 1 or type 2 diabetes around-the-clock glucose readings",
    },
    {
      id: 4,
      text: "Provides real-time, dynamic information about the speed and direction (trending higher or lower) of your glucose levels",
    },
    {
      id: 5,
      text: "Provides information necessary for you and your healthcare provider to determine how well your treatment plan is working",
    },
    {
      id: 6,
      text: "Helps you prevent serious complications from undetected low or high glucose levels",
    },
    {
      id: 7,
      text: "Reduces anxiety associated with not knowing how well you are managing your diabetes between visits with your healthcare provider",
    },
  ];

  const usageInstructions: { id: number; text: string }[] = [
    {
      id: 1,
      text: "Read the user manual for detailed usage instructions",
    },
    {
      id: 2,
      text: "Install the batteries, set the date and time in the Rossmax HS200 Blood Sugar Monitor (instructions in the manual provided)",
    },
    {
      id: 3,
      text:
        "To prepare the strips: Wash hands using soap and warm water. Rinse and dry thoroughly. " +
        "Insert the test strip, top side facing up into the test port. The meter will automatically turn on. " +
        "System checking will appear. A beep will sound, you can select the meal indicator for marking the test as pre-meal test, post-meal test, or no marker. " +
        "Note: Check if your meter displays the unit of measurement you are accustomed. A blood sample can now be obtained. " +
        "Note: The meter will shut off automatically after 2 minutes without any action",
    },
  ];

  return (
    <div className="w-full p-3 bg-banner-white-image py-8">
      <div className="view-area-width  box-design">
        <div className=" p-4 grid grid-cols-1 md:grid-cols-[30%,43%,25%] gap-4 bg-white rounded-md">
          {/* Left Column - Product Image & Thumbnails */}
          <div className="space-y-4">
            <div className="w-full box-design relative pb-3">
              <span className="bg-[#FFE4E4] py-2 px-4 text-[#EF4444] rounded-[50px] font-size-15px font-Lexend-Regular relative top-3 left-2">
                20% Off
              </span>
              <div className={"flex items-center justify-center mt-32"}>
                <img
                  src={DummyProduct}
                  alt="Maxi Collagen"
                  className="w-[50%] rounded-md"
                />
              </div>
              <div className="w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] cursor-pointer bg-[#E4E4E4] absolute top-2 right-2 rounded-full flex items-center justify-center">
                <img src={HeartUnFav} alt="HeartUnFav" className="w-[60%]" />
              </div>
              <div className="w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] cursor-pointer bg-[#E4E4E4] absolute top-14 right-2 rounded-full flex items-center justify-center">
                <img src={ShareIcon} alt="shareImg" />
              </div>
              <div className="h-[30px] w-[177px] bg-[#08911F] text-[#FFFFFF] rounded-[5px] font-size-15px mt-[120px] ml-2 flex justify-center items-center font-Lexend-Regular">
                Pharmacist Choice{" "}
                <img src={DangerImg} alt="Danger" className="pl-2" />
              </div>
            </div>
            <div className="customer-product-detail-slider">
              <ProductDetailSlider
                galleryImages={[
                  imagesPath,
                  imagesPath,
                  imagesPath,
                  imagesPath,
                  imagesPath,
                  imagesPath,
                ]}
                onThumbnailClick={handleThumbnailClick}
              />
            </div>
          </div>

          {/* Middle Column - Product Info */}
          <div className="space-y-4">
            <div className="box-design w-full">
              <div className="flex items-center gap-3 py-2 relative">
                {/* Brand Logo */}
                <div className="w-14 h-14 bg-white rounded-md overflow-hidden flex items-center justify-center">
                  <img
                    src={OgxImg}
                    alt="Ogx"
                    className="w-full h-full object-contain ml-2"
                  />
                </div>

                {/* Brand Info */}
                <div>
                  <h2 className="text-[#2D2D2D] font-Poppins-Medium font-size-16px">
                    Ogx
                  </h2>
                  <p className="text-[#3B82F6] font-Poppins-Regular font-size-14px">
                    Explore all the products
                  </p>
                </div>
                <div>
                  <ChevronRight
                    className="text-[#00443F] absolute right-2 top-6"
                    size={20}
                  />
                </div>
              </div>
            </div>
            <div>
              <h1 className="text-[#393939] font-Lexend-Regular font-size-25px">
                Ogx Biotin & Collagen Shampoo 385 Ml
              </h1>
              <p className="text-[#F59E0B] mt-2">
                ★★★★☆{" "}
                <span className="text-[#707070] font-Poppins-Regular font-size-16px">
                  {" "}
                  4.5 - 45 Reviews
                </span>
                <span
                  className={
                    "px-3 py-2 bg-[#F8FAFC] border border-[#F8FAFC] rounded-[25px] ml-4 font-Poppins-Regular font-size-15px text-[#707070]"
                  }
                >
                  SKU : 104458
                </span>
              </p>
              <div className="flex gap-2 mt-5">
                <span className="bg-[#F1F5F9] px-3 py-2 rounded-[10px] text-[#363636] font-Poppins-Regular font-size-14px ">
                  Immune Support
                </span>
                <span className="bg-[#F1F5F9] px-3 py-2 rounded-[10px] text-[#363636] font-Poppins-Regular font-size-14px ">
                  Free Testosterone
                </span>
              </div>
            </div>
            <div className="flex items-center justify-between gap-4">
              <p className="font-size-26px font-Poppins-SemiBold text-[#202020] pt-4">
                {CURRENCY} 1200.00
                <span className="line-through text-[#434343] font-Poppins-Regular font-size-19px pt-6 pl-8">
                  {CURRENCY} 250
                </span>
              </p>
              <div className="mt-4 flex gap-2 items-center">
                <span className="text-[#363636] font-Poppins-Regular font-size-16px">
                  Quantity
                </span>
                <button
                  className="px-2 text-xl bg-[#00625B] text-[#FFFF] border rounded-[2px]"
                  onClick={() => handleQuantityChange("dec")}
                >
                  -
                </button>
                <span className="text-[#202020] font-size-15px font-Poppins-Medium">
                  {quantity}
                </span>
                <button
                  className="px-2 text-xl bg-[#00625B] text-[#FFFF] border rounded-[2px]"
                  onClick={() => handleQuantityChange("inc")}
                >
                  +
                </button>
              </div>
            </div>
            <GradientBtn
              onPress={handleSubmit}
              ButtonText="Add to Cart"
              btnExtraStyle={{
                width: "100%",
                marginTop: "26px",
                paddingBlock: "10px",
                fontSize: "18px",
              }}
            />

            {/* Frequently Bought Together */}
            <div className="box-design p-3 pb-6">
              <h2 className="text-[#2D2D2D] mt-1 font-Poppins-SemiBold font-size-20px mb-2">
                Frequently Bought Together
              </h2>
              <div className="flex gap-4">
                {[1, 2].map((_, i) => (
                  <div
                    key={i}
                    className="border w-[250px] flex-shrink-0 rounded-[15px] overflow-hidden mt-4 pb-4"
                  >
                    <img
                      src={DummyProduct}
                      className="w-full h-32 object-contain mb-2 py-4  bg-[#F6F6F6]"
                      alt="Garden of Life"
                    />
                    <p className="text-[#3B3B3B] font-Poppins-Regular font-size-14px p-2">
                      Garden of Life Dr. Formulated
                    </p>
                    <p className="font-size-18px font-Poppins-SemiBold text-[#004540] pl-2">
                      {CURRENCY} 1200.00
                      <span className="line-through text-[#3B3B3B] font-Poppins-Regular font-size-15px pl-4 pr-5">
                        {CURRENCY} 250
                      </span>
                    </p>
                  </div>
                ))}
              </div>
              <div className="flex gap-3 mt-4 w-full relative items-center">
                <div className="flex flex-col">
                  <p className="font-size-20px font-Poppins-Medium text-[#202020] pl-1">
                    Total Amount
                  </p>
                  <p className="font-size-16px font-Poppins-Regular  text-[#555555] pl-1">
                    {CURRENCY} 57.14
                  </p>
                </div>
                <div className="flex flex-1">
                  <GradientBtn
                    isOutline={true}
                    onPress={handleSubmit}
                    ButtonText="Add to Cart"
                    btnExtraStyle={{
                      width: "100%",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Delivery Info */}
          <div className="space-y-4 text-sm">
            <div className="box-design rounded-[10px] p-4">
              <div className="flex gap-4">
                <div>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="text-[#2563EB] px-4 py-3 text-xl bg-[#E6EEFF] rounded-[10px] "
                  />
                </div>
                <div>
                  <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                    Deliver To:
                  </p>
                  <p className="text-[#5B5B5B] font-Poppins-Regular font-size-15px">
                    18 23rd St – Al Wasl – Dubai
                  </p>
                </div>
              </div>

              <div className="bg-[#F0FDF4] border border-[#22C55E] p-2 rounded-[10px] mt-4">
                <div className="flex gap-3 items-center">
                  <div>
                    <img src={HistoryIcon} alt="history_icon" />
                  </div>
                  <div>
                    <p className="flex gap-2 text-[#202020] font-Poppins-Regular font-size-15px">
                      Express Delivery
                    </p>
                    <p className="text-[#5B5B5B] font-Poppins-Regular font-size-14px">
                      In 30 min
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className=" flex gap-3 items-center border p-3 rounded">
                <div>
                  <img src={CarIcon} alt="car_icon" />
                </div>
                <div>
                  <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                    Free Delivery
                  </p>
                  <p className="text-[#5B5B5B] font-Poppins-Regular font-size-14px ">
                    Enjoy free delivery on all orders over {CURRENCY} 29
                  </p>
                  <a
                    href="#"
                    className="text-[#2563EB] underline hover:opacity-80 font-Poppins-Regular font-size-15px"
                  >
                    Learn More
                  </a>
                </div>
              </div>
              <div className=" flex gap-3 items-center border p-3 rounded">
                <div>
                  <img src={PhoneIcon} alt="car_icon" />
                </div>
                <div>
                  <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                    24/7 Customer Support
                  </p>
                  <p className="text-[#5B5B5B] font-Poppins-Regular font-size-14px ">
                    Receive dedicated support around the clock
                  </p>
                  <a
                    href="#"
                    className="text-[#2563EB] underline hover:opacity-80 font-Poppins-Regular font-size-15px"
                  >
                    Learn More
                  </a>
                </div>
              </div>
              <div className=" flex gap-3 items-center border p-3 rounded">
                <div>
                  <img src={CircleIcon} alt="car_icon" />
                </div>
                <div>
                  <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                    Easy Return
                  </p>
                  <p className="text-[#5B5B5B] font-Poppins-Regular font-size-14px ">
                    Benefit from our hassle-free return and refund policy
                  </p>
                  <a
                    href="#"
                    className="text-[#2563EB] underline hover:opacity-80 font-Poppins-Regular font-size-15px"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-4 mt-4 mx-4">
          <div className="flex flex-1">
            <img src={BannerImage1} alt="BannerImage1" />
          </div>
          <div className="flex flex-1">
            <img src={BannerImage2} alt="BannerImage2" />
          </div>
        </div>

        <div className="m-4 mx-5">
          <BoxWrapper
            title="Overview"
            extraTextStyle={{
              fontFamily: "Lexend-Medium",
              color: "#3E3E3E",
              fontSize: "25px",
            }}
          >
            <div className="bg-white p-4">
              <h3 className="text-[25px] font-Lexend-Medium text-[#3E3E3E] mb-4 relative right-2">
                Information
              </h3>

              <ul className="list-none space-y-2 relative right-2">
                {infoPoints.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start font-Lexend-Regular font-size-18px text-[#707070]"
                  >
                    <span className="w-2 h-2 mt-2 mr-2 rounded-full bg-gradient-to-b from-[#004540] to-[#00A297] flex-shrink-0"></span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </BoxWrapper>

          <div className="w-full bg-white py-6 px-4 rounded-md shadow-sm border mt-4">
            <h2 className="font-Lexend-Medium mb-4 font-size-25px text-[#3E3E3E]">
              Description
            </h2>
            <p className=" flex items-start font-Lexend-Regular font-size-18px text-[#707070]">
              Rossmax HS200 Blood Sugar Test Strips can eliminate interference
              from oxygen variations and non-glucose sugar such as maltose and
              galactose, providing you with the most reliable and accurate
              results. They provide full warranty and is suitable for self
              testing. Each strip can be used ONCE ONLY!. A test strip consists
              of the following parts: Target Area: Where a blood drop or control
              solution is touched. Confirmation Window: To confirm if sufficient
              blood drop or control solution has been applied to Target Area.
              Contact Bar: The end of the test strip is to be inserted into the
              test port (top side facing up). On each test strip the target area
              contains reaction chemicals. When blood is applied to this area, a
              chemical reaction takes place, then a transient electrical current
              is formed. The blood glucose concentration is calculated based on
              the electrical current detected by the meter, then the result is
              showed on the display. The test measures glucose from 20 mg/dL
              (1.1mmol/L) to 600 mg/dL (33.3mmol/L). The Rossmax HS200 Test
              Strip is calibrated to display the equivalent of plasma glucose
              values to allow easy comparison of results with laboratory
              methods.
            </p>
            <div className="bg-white p-4">
              <h3 className="font-Lexend-Medium mb-4 font-size-25px text-[#3E3E3E] relative right-2">
                Benefits
              </h3>

              <ul className="list-none space-y-2 relative right-2">
                {benefitsList.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start font-Lexend-Regular font-size-18px text-[#707070]"
                  >
                    <span className="w-2 h-2 mt-2 mr-2 rounded-full bg-gradient-to-b from-[#004540] to-[#00A297] flex-shrink-0"></span>
                    <span>{point.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white p-4">
              <h3 className="font-Lexend-Medium mb-4 font-size-25px text-[#3E3E3E] relative right-2">
                How to use
              </h3>

              <ul className="list-none space-y-2 relative right-2">
                {usageInstructions.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start font-Lexend-Regular font-size-18px text-[#707070]"
                  >
                    <span className="w-2 h-2 mt-2 mr-2 rounded-full bg-gradient-to-b from-[#004540] to-[#00A297] flex-shrink-0"></span>
                    <span>{point.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <BoxWrapper
            title="Overview"
            extraTextStyle={{
              fontFamily: "Lexend-Medium",
              color: "#3E3E3E",
              fontSize: "25px",
            }}
          >
            <div className="bg-white p-4">
              <h3 className="text-[25px] font-Lexend-Medium text-[#3E3E3E] mb-4 relative right-2">
                Information
              </h3>

              <ul className="list-none space-y-2 relative right-2">
                {infoPoints.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start font-Lexend-Regular font-size-18px text-[#707070]"
                  >
                    <span className="w-2 h-2 mt-2 mr-2 rounded-full bg-gradient-to-b from-[#004540] to-[#00A297] flex-shrink-0"></span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </BoxWrapper>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
